import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { WalletProvider } from "../contexts/WalletContext";
import { DialogProvider } from "../contexts/DialogContext";
import { FormProvider } from "../contexts/WalletFormContext";
import { TenantProvider } from "../contexts/TenantContext";
import { EmployeeProvider } from "../contexts/EmployeeContext";

export const WalletComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <WalletProvider key={0} />,
        <FormProvider key={1} />,
        <TenantProvider key={2} />,
        <EmployeeProvider key={3} />,
        <DialogProvider key={4} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
